import React, { useState } from "react";
import { FaPlus, FaTrashAlt } from "react-icons/fa";
import { useForm } from "react-hook-form";
import axios from "axios";
import Swal from "sweetalert2";
import { Modal, Spinner } from "react-bootstrap";

function DirectForm({ master, merchandise_types, years, goBack }) {
  const [formErrors, setFormErrors] = useState({});
  const [rowErrors, setRowErrors] = useState([]);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    piezas: "",
    grossWeight: "",
    chargeableWeight: "",
    volumen: "",
    tipo: 1,
    descripcion: "",
  });
  const [rows, setRows] = useState([
    {
      flight: "",
      year: "",
      time: "",
    },
  ]);
  const { register, watch, getValues } = useForm({
    defaultValues: {
      // Naturalez
      nat_cgo: master?.preve_save?.nat_cgo,
      nat_cgo_pieces: master?.preve_save?.nat_cgo_pieces || "",
      nat_cgo_weight: master?.preve_save?.nat_cgo_weight || "",
      nat_dgr: master?.preve_save?.nat_dgr,
      nat_dgr_pieces: master?.preve_save?.nat_dgr_pieces || "",
      nat_dgr_weight: master?.preve_save?.nat_dgr_weight || "",
      nat_per: master?.preve_save?.nat_per,
      nat_per_pieces: master?.preve_save?.nat_per_pieces || "",
      nat_per_weight: master?.preve_save?.nat_per_weight || "",
      nat_avi: master?.preve_save?.nat_avi,
      nat_avi_pieces: master?.preve_save?.nat_avi_pieces || "",
      nat_avi_weight: master?.preve_save?.nat_avi_weight || "",
      nat_val: master?.preve_save?.nat_val,
      nat_val_pieces: master?.preve_save?.nat_val_pieces || "",
      nat_val_weight: master?.preve_save?.nat_val_weight || "",
      nat_hum: master?.preve_save?.nat_hum,
      nat_hum_pieces: master?.preve_save?.nat_hum_pieces || "",
      nat_hum_weight: master?.preve_save?.nat_hum_weight || "",
      nat_dip: master?.preve_save?.nat_dip,
      nat_dip_pieces: master?.preve_save?.nat_dip_pieces || "",
      nat_dip_weight: master?.preve_save?.nat_dip_weight || "",
      nat_nwp: master?.preve_save?.nat_nwp,
      nat_nwp_pieces: master?.preve_save?.nat_nwp_pieces || "",
      nat_nwp_weight: master?.preve_save?.nat_nwp_weight || "",
      nat_mal: master?.preve_save?.nat_mal,
      nat_mal_pieces: master?.preve_save?.nat_mal_pieces || "",
      nat_mal_weight: master?.preve_save?.nat_mal_weight || "",
      nat_com: master?.preve_save?.nat_com,
      nat_com_pieces: master?.preve_save?.nat_com_pieces || "",
      nat_com_weight: master?.preve_save?.nat_com_weight || "",
      nat_vic: master?.preve_save?.nat_vic,
      nat_vic_pieces: master?.preve_save?.nat_vic_pieces || "",
      nat_vic_weight: master?.preve_save?.nat_vic_weight || "",
      nat_pil: master?.preve_save?.nat_pil,
      nat_pil_pieces: master?.preve_save?.nat_pil_pieces || "",
      nat_pil_weight: master?.preve_save?.nat_pil_weight || "",

      // Manejo
      han_ice: master?.preve_save?.han_ice,
      han_ice_pieces: master?.preve_save?.han_ice_pieces || "",
      han_ice_weight: master?.preve_save?.han_ice_weight || "",
      han_wet: master?.preve_save?.han_wet,
      han_wet_pieces: master?.preve_save?.han_wet_pieces || "",
      han_wet_weight: master?.preve_save?.han_wet_weight || "",
      han_big: master?.preve_save?.han_big,
      han_big_pieces: master?.preve_save?.han_big_pieces || "",
      han_big_weight: master?.preve_save?.han_big_weight || "",
      han_hea: master?.preve_save?.han_hea,
      han_hea_pieces: master?.preve_save?.han_hea_pieces || "",
      han_hea_weight: master?.preve_save?.han_hea_weight || "",
      han_hwc: master?.preve_save?.han_hwc,
      han_hwc_pieces: master?.preve_save?.han_hwc_pieces || "",
      han_hwc_weight: master?.preve_save?.han_hwc_weight || "",
      han_col: master?.preve_save?.han_col,
      han_col_pieces: master?.preve_save?.han_col_pieces || "",
      han_col_weight: master?.preve_save?.han_col_weight || "",
      han_fro: master?.preve_save?.han_fro,
      han_fro_pieces: master?.preve_save?.han_fro_pieces || "",
      han_fro_weight: master?.preve_save?.han_fro_weight || "",
      han_na: master?.preve_save?.han_na,
      han_na_pieces: master?.preve_save?.han_na_pieces || "",
      han_na_weight: master?.preve_save?.han_na_weight || "",
    },
  });
  const [loading, setLoading] = useState(false);

  const currentYear = new Date().getFullYear();

  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value });

    if (formErrors[field]) {
      setFormErrors({ ...formErrors, [field]: "" });
    }
  };

  const handleAddRow = () => {
    setRows([...rows, { flight: "", year: currentYear.toString(), time: "" }]);
  };

  const handleDeleteRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };

  const handleRowInputChange = (index, field, value, format = false) => {
    const updatedRows = [...rows];
    if (field === "flight") {
      value = value.toUpperCase();
      if (format) {
        let data = value.split("/");
        let prefix = data[0].substring(0, 2);
        let rest = data[0].substring(2);
        if (prefix === "AM") {
          let formattedRest = rest;
          if (rest.length === 1) formattedRest = "000" + rest;
          else if (rest.length === 2) formattedRest = "00" + rest;
          else if (rest.length === 3) formattedRest = "0" + rest;
          else if (rest.length >= 4) formattedRest = rest.substring(0, 4);
          const flightFormatted = "AM" + formattedRest;
          value =
            data[1] === undefined
              ? `${flightFormatted}/`
              : `${flightFormatted}/${data[1]}`;
        }
        if (value.length > 0 && rowErrors[index]?.vuelo) {
          const updatedErrors = [...rowErrors];

          if (value.length >= 10) {
            const isValid = /^AM\d{4}\/(0[1-9]|[12][0-9]|3[01])(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)$/.test(value);

            if (!isValid) {
              updatedErrors[index].vuelo = "Formato inválido (AM1030/22MAY)";
            } else {
              updatedErrors[index].vuelo = "";
            }
          }
          if (updatedErrors[index]) updatedErrors[index].vuelo = "";
          setRowErrors(updatedErrors);
        }
      }
    }
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const validateRequiredFields = (fields, data) => {
    const errors = {};

    fields.forEach((field) => {
      if (
        data[field] === undefined ||
        data[field] === null ||
        data[field].toString().trim() === ""
      ) {
        errors[field] = "Este campo es obligatorio";
      }
    });

    return errors;
  };

  const handleSave = async () => {
    setLoading(true);
    const REQUIRED_MASTER_FIELDS = [
      "piezas",
      "grossWeight",
      "chargeableWeight",
      "volumen",
      "tipo",
      "fecha",
      "hora",
      "descripcion",
    ];

    const errors = validateRequiredFields(REQUIRED_MASTER_FIELDS, formData);

    if (Object.keys(errors).length > 0) {
      setLoading(false);
      setFormErrors(errors);
      return;
    }

    const rowErrors = rows.map((row) => {
      const err = {};
      if (!row.flight || row.flight.trim() === "")
        err.flight = "Este campo es obligatorio";
      if (!row.year || row.year.toString().trim() === "")
        err.year = "Este campo es obligatorio";
      if (!row.time || row.time.trim() === "")
        err.time = "Este campo es obligatorio";
      return err;
    });

    const hayErroresEnRows = rowErrors.some(
      (rowErr) => Object.keys(rowErr).length > 0
    );

    if (hayErroresEnRows) {
      setLoading(false);
      setRowErrors(rowErrors);
      return;
    }

    setRowErrors([]);

    const vueloRegex = /^AM\d{4}\/(0[1-9]|[12][0-9]|3[01])(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)$/;

    const vuelosFormateados = rows.map((row) => {
      const v = row.flight.trim().toUpperCase();
      const [aerolineaYNumero, fecha] = v.split("/");

      if (!aerolineaYNumero || !fecha) return v;

      const letras = aerolineaYNumero.slice(0, 2);
      const numeros = aerolineaYNumero.slice(2).padStart(4, "0");

      return `${letras}${numeros}/${fecha.toUpperCase()}`;
    });

    const vuelosInvalidos = vuelosFormateados.filter(
      (v) => !vueloRegex.test(v)
    );

    if (vuelosInvalidos.length > 0) {
      setLoading(false);
      Swal.fire({
        title: "Formato de vuelo inválido",
        text: `Verifica: ${vuelosInvalidos.join(", ")}`,
        icon: "error",
        iconColor: "#ED1B1B",
      });
      return;
    }

    const vuelosDuplicados = vuelosFormateados.filter(
      (v, i, self) => self.indexOf(v) !== i
    );

    if (vuelosDuplicados.length > 0) {
      setLoading(false);
      Swal.fire({
        title: "Vuelos duplicados",
        text: `Vuelos repetidos: ${vuelosDuplicados.join(", ")}`,
        icon: "warning",
        iconColor: "#FCC732",
      });
      return;
    }

    const rhfData = getValues();

    const totalPieces = Number(formData.piezas);
    const totalWeight = Number(formData.grossWeight);

    const natPieces = Object.keys(rhfData)
      .filter((k) => k.startsWith("nat_") && k.endsWith("_pieces"))
      .reduce((s, k) => s + Number(rhfData[k] || 0), 0);

    const natWeight = Object.keys(rhfData)
      .filter((k) => k.startsWith("nat_") && k.endsWith("_weight"))
      .reduce((s, k) => s + Number(rhfData[k] || 0), 0);

    const hanPieces = Object.keys(rhfData)
      .filter((k) => k.startsWith("han_") && k.endsWith("_pieces"))
      .reduce((s, k) => s + Number(rhfData[k] || 0), 0);

    const hanWeight = Object.keys(rhfData)
      .filter((k) => k.startsWith("han_") && k.endsWith("_weight"))
      .reduce((s, k) => s + Number(rhfData[k] || 0), 0);

    if (
      natPieces !== totalPieces ||
      hanPieces !== totalPieces ||
      natWeight !== totalWeight ||
      hanWeight !== totalWeight
    ) {
      setLoading(false);
      setError(
        "Las piezas y peso de naturaleza y manejo no coinciden con el total. Favor de verificar."
      );
      return;
    }

    setError("");

    if (natPieces <= 0 || hanPieces <= 0 || natWeight <= 0 || hanWeight <= 0) {
      setLoading(false);
      setError("No se ha capturado naturaleza y/o manejo de la carga.");
      return;
    }

    setError("");

    if (hasCol) {
      const bookingCol = rhfData.booking_col || [];
      let errorMessage = "";

      const errorCol = rows.some((_, i) => {
        const row = bookingCol[i] || {};
        const pieces = Number(row.pieces);
        const weight = Number(row.weight);
        const cp_pieces = Number(rhfData.han_col_pieces);
        const cp_weight = Number(rhfData.han_col_weight);

        if (!pieces || !weight) {
          errorMessage =
            "Debe capturar piezas y peso en todos los vuelos de REFRI";
          return true;
        }

        if (pieces > cp_pieces || weight > cp_weight) {
          errorMessage =
            errorMessage = "Las piezas o peso capturados en vuelos REFRI exceden el total de manejo.";
          return true;
        }

        return false;

      });

      if (errorCol) {
        setLoading(false);
        Swal.fire({
          title: "Error",
          text: errorMessage,
          icon: "error",
        });
        return;
      }
    }

    if (hasFro) {
      const bookingFro = rhfData.booking_fro || [];
      let errorMessage = "";

      const errorFro = rows.some((_, i) => {
        const row = bookingFro[i] || {};
        const pieces = Number(row.pieces);
        const weight = Number(row.weight);
        const cp_pieces = Number(rhfData.han_fro_pieces);
        const cp_weight = Number(rhfData.han_fro_weight);

        if (!pieces || !weight) {
          errorMessage =
            "Debe capturar piezas y peso en todos los vuelos de CONGELADOR";
          return true;
        }

        if (pieces > cp_pieces || weight > cp_weight) {
          errorMessage =
            "Las piezas capturadas en los vuelos de CONGELAODR no pueden ser mayores a las de CONGELADOR";
          return true;
        }
        return false;
      });

      if (errorFro) {
        setLoading(false);
        Swal.fire({
          title: "Error",
          text: errorMessage,
          icon: "error",
        });
        return;
      }
    }

    if (hasDgr && (rhfData.has_dg_exempt === undefined || rhfData.has_dg_exempt === null)) {
      setLoading(false);
      Swal.fire({
        title: "Error",
        text: "Debe indicar si contiene DG exentas de verificación",
        icon: "error",
      });
      return;
    }


    try {
      const payload = {
        type: 1,
        awb: master.master,

        pieces: formData.piezas,
        weight: formData.grossWeight,
        chargeable_weight: formData.chargeableWeight,
        volume: formData.volumen,
        merchandise_type: formData.tipo,
        description: formData.descripcion,
        reception_date: formData.fecha,
        reception_time: formData.hora,

        flight: vuelosFormateados,
        year: rows.map((r) => r.year),
        time: rows.map((r) => r.time),

        boobking_pieces_col: (rhfData.booking_col || []).map(r => r?.pieces || "0"),
        boobking_weight_col: (rhfData.booking_col || []).map(r => r?.weight || "0"),

        boobking_pieces_fro: (rhfData.booking_fro || []).map(r => r?.pieces || "0"),
        boobking_weight_fro: (rhfData.booking_fro || []).map(r => r?.weight || "0"),

        ...rhfData,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_administrative_billing/fact_admin_data_save`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
          },
        }
      );

      if (response.data.code === 1) {
        setLoading(false);
        goBack();
        Swal.fire({
          title: "Guardado",
          text: response.data.message,
          icon: "success",
          iconColor: "#1B9925",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
      }
    } catch (error) {
      setLoading(false);
      Swal.fire({
        title: "Error",
        text: "Ocurrió un error al guardar la información",
        icon: "error",
      });
    }
  };

  const hasCol = watch("han_col"); // REFRI
  const hasFro = watch("han_fro"); // CONGELADOR
  const hasDgr = watch("nat_dgr"); // DG

  const onlyNumbersPieces = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    e.target.value = value;
  };

  const onlyNumbers = (e) => {
    let value = e.target.value;

    // Permite solo números y punto
    value = value.replace(/[^0-9.]/g, "");

    // Evita más de un punto decimal
    const parts = value.split(".");
    if (parts.length > 2) {
      value = parts[0] + "." + parts.slice(1).join("");
    }

    e.target.value = value;
  };

  return (
    <>
      <div className="row mb-4">
        {[
          { label: "Piezas Master", key: "piezas" },
          { label: "Gross Weight Master", key: "grossWeight" },
          { label: "Chargeable Weight Master", key: "chargeableWeight" },
          { label: "Volumen Master", key: "volumen" },
          { label: "Tipo de mercancia", key: "tipo" },
          { label: "Fecha recepción", key: "fecha" },
          { label: "Hora recepción", key: "hora" },
          { label: "Descripción Master", key: "descripcion" },
        ].map((item, index) => (
          <div key={index} className="col-md-4 mb-3">
            <label className="form-label fw-bold">{item.label}</label>
            {item.key === "tipo" ? (
              <>
                <select
                  className="form-select"
                  value={formData.tipo || ""}
                  onChange={(e) => handleInputChange("tipo", e.target.value)}
                >
                  <option value="">Seleccione...</option>
                  {Object.entries(merchandise_types || {}).map(
                    ([id, label]) => (
                      <option key={id} value={id}>
                        {label}
                      </option>
                    )
                  )}
                </select>
                {formErrors.tipo && (
                  <small className="text-danger">{formErrors.tipo}</small>
                )}
              </>
            ) : item.key === "descripcion" ? (
              <>
                <textarea
                  className="form-control"
                  rows="2"
                  value={formData.descripcion || ""}
                  onChange={(e) =>
                    handleInputChange("descripcion", e.target.value)
                  }
                />
                {formErrors.descripcion && (
                  <small className="text-danger">
                    {formErrors.descripcion}
                  </small>
                )}
              </>
            ) : (
              <>
                <input
                  type={
                    item.key === "fecha"
                      ? "date"
                      : item.key === "hora"
                        ? "time"
                        : "text"
                  }
                  className="form-control"
                  value={formData[item.key] || ""}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (item.key === "piezas") {
                      if (/^\d*$/.test(value)) {
                        handleInputChange("piezas", value);
                      }
                    } else if (
                      ["grossWeight", "chargeableWeight", "volumen"].includes(
                        item.key
                      )
                    ) {
                      if (/^\d*\.?\d*$/.test(value)) {
                        handleInputChange(item.key, value);
                      }
                    } else {
                      handleInputChange(item.key, value);
                    }
                  }}
                />

                {formErrors[item.key] && (
                  <small className="text-danger">{formErrors[item.key]}</small>
                )}
              </>
            )}
          </div>
        ))}
      </div>

      <div className="row mt-4 mb-4">
        <div className="col-md-12">
          <table
            className="table mx-auto"
            style={{ maxWidth: "800px", width: "100%" }}
          >
            <thead className="table-light fondo-headUPD">
              <tr>
                <th>* Vuelo</th>
                <th>* Año</th>
                <th>* Hora Vuelo</th>
                <th>Eliminar</th>
              </tr>
            </thead>

            <tbody>
              {rows.map((row, index) => (
                <tr key={index}>
                  {/* Vuelo */}
                  <td>
                    <input
                      type="text"
                      className={`form-control ${rowErrors[index]?.flight ? "is-invalid" : ""
                        }`}
                      value={row.flight}
                      onChange={(e) =>
                        handleRowInputChange(
                          index,
                          "flight",
                          e.target.value,
                          false
                        )
                      }
                      onBlur={(e) =>
                        handleRowInputChange(
                          index,
                          "flight",
                          e.target.value,
                          true
                        )
                      }
                    />
                    {rowErrors[index]?.flight && (
                      <div className="invalid-feedback">
                        {rowErrors[index].flight}
                      </div>
                    )}
                  </td>

                  {/* Año */}
                  <td>
                    <select
                      className={`form-select ${rowErrors[index]?.year ? "is-invalid" : ""
                        }`}
                      value={row.year}
                      onChange={(e) =>
                        handleRowInputChange(index, "year", e.target.value)
                      }
                    >
                      <option value="">Seleccione</option>
                      {years.map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                    {rowErrors[index]?.year && (
                      <div className="invalid-feedback">
                        {rowErrors[index].year}
                      </div>
                    )}
                  </td>

                  {/* Hora */}
                  <td>
                    <input
                      type="time"
                      className={`form-control ${rowErrors[index]?.time ? "is-invalid" : ""
                        }`}
                      value={row.time}
                      onChange={(e) =>
                        handleRowInputChange(index, "time", e.target.value)
                      }
                    />
                    {rowErrors[index]?.time && (
                      <div className="invalid-feedback">
                        {rowErrors[index].time}
                      </div>
                    )}
                  </td>

                  {/* Eliminar */}
                  <td className="text-center">
                    {index > 0 && (
                      <button
                        type="button"
                        className="btn iconoTrash"
                        onClick={() => handleDeleteRow(index)}
                      >
                        <FaTrashAlt />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Botón agregar fila */}
          <div className="text-center mt-3">
            <button className="btnn" onClick={handleAddRow}>
              <FaPlus />
            </button>
          </div>
        </div>
      </div>

      <table className="table table-striped mt-4">
        <colgroup>
          <col style={{ width: "10%" }} />
          <col style={{ width: "20%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "20%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "10%" }} />
        </colgroup>
        <thead className="text-center">
          <tr>
            <th style={{ backgroundColor: "#020C41", color: "white" }}>
              NATURALEZA
            </th>
            <th style={{ backgroundColor: "#020C41", color: "white" }}></th>
            <th style={{ backgroundColor: "#020C41", color: "white" }}>
              Piezas
            </th>
            <th style={{ backgroundColor: "#020C41", color: "white" }}>Peso</th>
            <th style={{ backgroundColor: "#020C41", color: "white" }}>
              MANEJO
            </th>
            <th style={{ backgroundColor: "#020C41", color: "white" }}>
              MANEJO
            </th>
            <th style={{ backgroundColor: "#020C41", color: "white" }}>
              Piezas
            </th>
            <th style={{ backgroundColor: "#020C41", color: "white" }}>Peso</th>
          </tr>
        </thead>
        <tbody className="text-center">
          {/* Fila CGO (GENERAL) */}
          <tr className="text-start">
            <td className="text-end">CGO</td>
            <td>
              <input
                type="checkbox"
                {...register("nat_cgo")}
                defaultChecked={master?.preve_save?.nat_cgo === "1"}
              />{" "}
              GENERAL
            </td>
            <td>
              {watch("nat_cgo") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_cgo_pieces")}
                  defaultValue={master?.preve_save?.nat_cgo_pieces || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbersPieces}
                />
              )}
            </td>
            <td>
              {watch("nat_cgo") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  className="form-control form-control-sm"
                  defaultValue={master?.preve_save?.nat_cgo_weight || ""}
                  {...register("nat_cgo_weight")}
                  onChange={onlyNumbers}
                />
              )}
            </td>
            <td className="text-end">ICE</td>
            <td>
              <input
                type="checkbox"
                {...register("han_ice")}
                defaultChecked={master?.preve_save?.han_ice === "1"}
              />{" "}
              HIELO-SECO
            </td>
            <td>
              {watch("han_ice") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("han_ice_pieces")}
                  defaultValue={master?.preve_save?.han_ice_pieces || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbersPieces}
                />
              )}
            </td>
            <td>
              {watch("han_ice") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("han_ice_weight")}
                  defaultValue={master?.preve_save?.han_ice_weight || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbers}
                />
              )}
            </td>
          </tr>

          {/* Fila DGR (PELIGROSA) */}
          <tr className="text-start">
            <td className="text-end">DGR</td>
            <td>
              <input
                type="checkbox"
                {...register("nat_dgr")}
                defaultChecked={master?.preve_save?.nat_dgr === "1"}
              />{" "}
              PELIGROSA
            </td>
            <td>
              {watch("nat_dgr") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_dgr_pieces")}
                  defaultValue={master?.preve_save?.nat_dgr_pieces || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbersPieces}
                />
              )}
            </td>
            <td>
              {watch("nat_dgr") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_dgr_weight")}
                  defaultValue={master?.preve_save?.nat_dgr_weight || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbers}
                />
              )}
            </td>
            <td className="text-end">WET</td>
            <td>
              <input
                type="checkbox"
                {...register("han_wet")}
                defaultChecked={master?.preve_save?.han_wet === "1"}
              />{" "}
              HÚMEDA
            </td>
            <td>
              {watch("han_wet") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("han_wet_pieces")}
                  defaultValue={master?.preve_save?.han_wet_pieces || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbersPieces}
                />
              )}
            </td>
            <td>
              {watch("han_wet") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("han_wet_weight")}
                  defaultValue={master?.preve_save?.han_wet_weight || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbers}
                />
              )}
            </td>
          </tr>

          {/* Fila PER (PERECEDERO) */}
          <tr className="text-start">
            <td className="text-end">PER</td>
            <td>
              <input
                type="checkbox"
                {...register("nat_per")}
                defaultChecked={master?.preve_save?.nat_per === "1"}
              />{" "}
              PERECEDERO
            </td>
            <td>
              {watch("nat_per") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_per_pieces")}
                  defaultValue={master?.preve_save?.nat_per_pieces || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbersPieces}
                />
              )}
            </td>
            <td>
              {watch("nat_per") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_per_weight")}
                  defaultValue={master?.preve_save?.nat_per_weight || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbers}
                />
              )}
            </td>
            <td className="text-end">BIG</td>
            <td>
              <input
                type="checkbox"
                {...register("han_big")}
                defaultChecked={master?.preve_save?.han_big === "1"}
              />{" "}
              GRANDE
            </td>
            <td>
              {watch("han_big") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("han_big_pieces")}
                  defaultValue={master?.preve_save?.han_big_pieces || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbersPieces}
                />
              )}
            </td>
            <td>
              {watch("han_big") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("han_big_weight")}
                  defaultValue={master?.preve_save?.han_big_weight || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbers}
                />
              )}
            </td>
          </tr>

          {/* Fila AVI (ANIMAL VIVO) */}
          <tr className="text-start">
            <td className="text-end">AVI</td>
            <td>
              <input
                type="checkbox"
                {...register("nat_avi")}
                defaultChecked={master?.preve_save?.nat_avi === "1"}
              />{" "}
              ANIMAL VIVO
            </td>
            <td>
              {watch("nat_avi") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_avi_pieces")}
                  defaultValue={master?.preve_save?.nat_avi_pieces || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbersPieces}
                />
              )}
            </td>
            <td>
              {watch("nat_avi") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_avi_weight")}
                  defaultValue={master?.preve_save?.nat_avi_weight || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbers}
                />
              )}
            </td>
            <td className="text-end">HEA</td>
            <td>
              <input
                type="checkbox"
                {...register("han_hea")}
                defaultChecked={master?.preve_save?.han_hea === "1"}
              />{" "}
              HEAVY
            </td>
            <td>
              {watch("han_hea") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("han_hea_pieces")}
                  defaultValue={master?.preve_save?.han_hea_pieces || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbersPieces}
                />
              )}
            </td>
            <td>
              {watch("han_hea") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("han_hea_weight")}
                  defaultValue={master?.preve_save?.han_hea_weight || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbers}
                />
              )}
            </td>
          </tr>

          {/* Fila VAL (ALTO VALOR) */}
          <tr className="text-start">
            <td className="text-end">VAL</td>
            <td>
              <input
                type="checkbox"
                {...register("nat_val")}
                defaultChecked={master?.preve_save?.nat_val === "1"}
              />{" "}
              ALTO VALOR
            </td>
            <td>
              {watch("nat_val") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_val_pieces")}
                  defaultValue={master?.preve_save?.nat_val_pieces || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbersPieces}
                />
              )}
            </td>
            <td>
              {watch("nat_val") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_val_weight")}
                  defaultValue={master?.preve_save?.nat_val_weight || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbers}
                />
              )}
            </td>
            <td className="text-end">HWC</td>
            <td>
              <input
                type="checkbox"
                {...register("han_hwc")}
                defaultChecked={master?.preve_save?.han_hwc === "1"}
              />{" "}
              FRAGIL
            </td>
            <td>
              {watch("han_hwc") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("han_hwc_pieces")}
                  defaultValue={master?.preve_save?.han_hwc_pieces || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbersPieces}
                />
              )}
            </td>
            <td>
              {watch("han_hwc") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("han_hwc_weight")}
                  defaultValue={master?.preve_save?.han_hwc_weight || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbers}
                />
              )}
            </td>
          </tr>

          {/* Fila HUM (RESTOS HUMANOS) */}
          <tr className="text-start">
            <td className="text-end">HUM</td>
            <td>
              <input
                type="checkbox"
                {...register("nat_hum")}
                defaultChecked={master?.preve_save?.nat_hum === "1"}
              />{" "}
              RESTOS HUMANOS
            </td>
            <td>
              {watch("nat_hum") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_hum_pieces")}
                  defaultValue={master?.preve_save?.nat_hum_pieces || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbersPieces}
                />
              )}
            </td>
            <td>
              {watch("nat_hum") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_hum_weight")}
                  defaultValue={master?.preve_save?.nat_hum_weight || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbers}
                />
              )}
            </td>
            <td className="text-end">COL</td>
            <td>
              <input
                type="checkbox"
                {...register("han_col")}
                defaultChecked={master?.preve_save?.han_col === "1"}
              />{" "}
              REFRI
            </td>
            <td>
              {watch("han_col") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("han_col_pieces")}
                  defaultValue={master?.preve_save?.han_col_pieces || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbersPieces}
                />
              )}
            </td>
            <td>
              {watch("han_col") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("han_col_weight")}
                  defaultValue={master?.preve_save?.han_col_weight || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbers}
                />
              )}
            </td>
          </tr>

          {/* Fila DIP (VALIJA DIPLOMATICA) */}
          <tr className="text-start">
            <td className="text-end">DIP</td>
            <td>
              <input
                type="checkbox"
                {...register("nat_dip")}
                defaultChecked={master?.preve_save?.nat_dip === "1"}
              />{" "}
              VALIJA DIPLOMATICA
            </td>
            <td>
              {watch("nat_dip") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_dip_pieces")}
                  defaultValue={master?.preve_save?.nat_dip_pieces || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbersPieces}
                />
              )}
            </td>
            <td>
              {watch("nat_dip") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_dip_weight")}
                  defaultValue={master?.preve_save?.nat_dip_weight || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbers}
                />
              )}
            </td>
            <td className="text-end">FRO</td>
            <td>
              <input
                type="checkbox"
                {...register("han_fro")}
                defaultChecked={master?.preve_save?.han_fro === "1"}
              />{" "}
              CONGELADOR
            </td>
            <td>
              {watch("han_fro") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("han_fro_pieces")}
                  defaultValue={master?.preve_save?.han_fro_pieces || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbersPieces}
                />
              )}
            </td>
            <td>
              {watch("han_fro") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("han_fro_weight")}
                  defaultValue={master?.preve_save?.han_fro_weight || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbers}
                />
              )}
            </td>
          </tr>

          {/* Fila NWP (PRENSA) */}
          <tr className="text-start">
            <td className="text-end">NWP</td>
            <td>
              <input
                type="checkbox"
                {...register("nat_nwp")}
                defaultChecked={master?.preve_save?.nat_nwp === "1"}
              />{" "}
              PRENSA
            </td>
            <td>
              {watch("nat_nwp") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_nwp_pieces")}
                  defaultValue={master?.preve_save?.nat_nwp_pieces || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbersPieces}
                />
              )}
            </td>
            <td>
              {watch("nat_nwp") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_nwp_weight")}
                  defaultValue={master?.preve_save?.nat_nwp_weight || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbers}
                />
              )}
            </td>
            <td className="text-end">N/A</td>
            <td>
              <input
                type="checkbox"
                {...register("han_na")}
                defaultChecked={master?.preve_save?.han_na === "1"}
              />{" "}
              NO APLICA
            </td>
            <td>
              {watch("han_na") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("han_na_pieces")}
                  defaultValue={master?.preve_save?.han_na_pieces || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbersPieces}
                />
              )}
            </td>
            <td>
              {watch("han_na") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("han_na_weight")}
                  defaultValue={master?.preve_save?.han_na_weight || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbers}
                />
              )}
            </td>
          </tr>

          {/* Fila MAL (MAIL) */}
          <tr className="text-start">
            <td className="text-end">MAL</td>
            <td>
              <input
                type="checkbox"
                {...register("nat_mal")}
                defaultChecked={master?.preve_save?.nat_mal === "1"}
              />{" "}
              MAIL
            </td>
            <td>
              {watch("nat_mal") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_mal_pieces")}
                  defaultValue={master?.preve_save?.nat_mal_pieces || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbersPieces}
                />
              )}
            </td>
            <td>
              {watch("nat_mal") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_mal_weight")}
                  defaultValue={master?.preve_save?.nat_mal_weight || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbers}
                />
              )}
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>

          {/* Fila COM (COMAT AM) */}
          <tr className="text-start">
            <td className="text-end">COM</td>
            <td>
              <input
                type="checkbox"
                {...register("nat_com")}
                defaultChecked={master?.preve_save?.nat_com === "1"}
              />{" "}
              COMAT AM
            </td>
            <td>
              {watch("nat_com") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_com_pieces")}
                  defaultValue={master?.preve_save?.nat_com_pieces || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbersPieces}
                />
              )}
            </td>
            <td>
              {watch("nat_com") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_com_weight")}
                  defaultValue={master?.preve_save?.nat_com_weight || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbers}
                />
              )}
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>

          {/* Fila VIC (VALOR DECLARADO) */}
          <tr className="text-start">
            <td className="text-end">VIC</td>
            <td>
              <input
                type="checkbox"
                {...register("nat_vic")}
                defaultChecked={master?.preve_save?.nat_vic === "1"}
              />{" "}
              VALOR DECLARADO
            </td>
            <td>
              {watch("nat_vic") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_vic_pieces")}
                  defaultValue={master?.preve_save?.nat_vic_pieces || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbersPieces}
                />
              )}
            </td>
            <td>
              {watch("nat_vic") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_vic_weight")}
                  defaultValue={master?.preve_save?.nat_vic_weight || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbers}
                />
              )}
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>

          {/* Fila PIL (PHARMA) */}
          <tr className="text-start">
            <td className="text-end">PIL</td>
            <td>
              <input
                type="checkbox"
                {...register("nat_pil")}
                defaultChecked={master?.preve_save?.nat_pil === "1"}
              />{" "}
              PHARMA
            </td>
            <td>
              {watch("nat_pil") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_pil_pieces")}
                  defaultValue={master?.preve_save?.nat_pil_pieces || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbersPieces}
                />
              )}
            </td>
            <td>
              {watch("nat_pil") && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("nat_pil_weight")}
                  defaultValue={master?.preve_save?.nat_pil_weight || ""}
                  className="form-control form-control-sm"
                  onChange={onlyNumbers}
                />
              )}
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>

      {hasCol && (
        <div className="row justify-content-center mt-4">
          <div className="col-md-8 px-0">
            <h3 className="mb-5">
              <strong>Vuelos Reservados Refri</strong>
            </h3>

            <table className="table">
              <thead>
                <tr>
                  <th >Vuelo</th>
                  <th>Año</th>
                  <th >Hora</th>
                  <th>Piezas</th>
                  <th>Peso</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, i) => (
                  <tr key={i}>
                    <td className="text-center" width="20%">{row.flight}</td>
                    <td className="text-center" width="20%">{row.year}</td>
                    <td className="text-center" width="20%">{row.time}</td>
                    <td className="text-center" width="20%">
                      <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        className="form-control form-control-sm"
                        {...register(`booking_col.${i}.pieces`)}
                        onChange={onlyNumbersPieces}
                      />
                    </td>
                    <td className="text-center" width="20%">
                      <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        className="form-control form-control-sm"
                        {...register(`booking_col.${i}.weight`)}
                        onChange={onlyNumbers}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {hasFro && (
        <div className="row justify-content-center mt-4">
          <div className="col-md-8 px-0">
            <h3 className="mb-5">
              <strong>Vuelos Reservados Conge</strong>
            </h3>

            <table className="table">
              <thead>
                <tr>
                  <th>Vuelo</th>
                  <th>Año</th>
                  <th>Hora</th>
                  <th>Piezas</th>
                  <th>Peso</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, i) => (
                  <tr key={i}>
                    <td className="text-center" width="20%">{row.flight}</td>
                    <td className="text-center" width="20%">{row.year}</td>
                    <td className="text-center" width="20%">{row.time}</td>
                    <td className="text-center" width="20%">
                      <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        className="form-control form-control-sm"
                        {...register(`booking_fro.${i}.pieces`)}
                        onChange={onlyNumbersPieces}
                      />
                    </td>
                    <td className="text-center" width="20%">
                      <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        className="form-control form-control-sm"
                        {...register(`booking_fro.${i}.weight`)}
                        onChange={onlyNumbers}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {hasDgr && (
        <div className="row mt-4">
          <div className="col-md-10 offset-md-1">
            <h4>¿Contiene DG exentas de verificación?</h4>

            <label className="me-3">
              <input type="radio" value="1" {...register("has_dg_exempt")} /> SÍ
            </label>

            <label>
              <input type="radio" value="0" {...register("has_dg_exempt")} /> NO
            </label>
          </div>
        </div>
      )}

      {error && (
        <div className="alert alert-danger text-center mt-3">{error}</div>
      )}
      <div className="row mt-4">
        <div className="col-12 text-end">
          <button
            type="submit"
            class="btn btn-primary"
            id="save1"
            onClick={handleSave}
          >
            Guardar
          </button>
        </div>
      </div>

      <Modal
        show={loading}
        onHide={() => setLoading(false)}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="custom-modal"
        backdropClassName="custom-backdrop"
      >
        <div className="spinner-container">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
        </div>
      </Modal>
    </>
  );
}

export default DirectForm;
